module.exports = __webpack_public_path__ + "img/mask-triangle.45eb3776.svg";